import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import DeleteUgcForm from 'app/components/bibs/shared/ugc/DeleteUgcForm';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

export default function DeleteCommentModal({
  commentId,
  catalogBib,
  commentsActions,
  handleSuccess,
  modalActions,
  commentsTransactions
}) {
  function handleClose() {
    modalActions.closeModal(`delete-comment-${commentId}`);
  }

  return (
    <ModalContainer
      className="cp-delete-comment-modal"
      modalKey={`delete-comment-${commentId}`}
      size="small"
      handleClose={handleClose}
    >
      <DeleteUgcForm
        ugcType="comment"
        id={commentId}
        catalogBib={catalogBib}
        removeUgcAction={commentsActions.removeComment}
        transactions={commentsTransactions}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
      />
    </ModalContainer>
  );
}

DeleteCommentModal.propTypes = {
  commentId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
